import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuthStore } from '@/stores';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const navigate = useNavigate();
  const { setUser, setLoading } = useAuthStore();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the magic link callback (from email link)
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (error) {
          console.error('Auth callback error:', error);
          setLoading(false);
          // Don't set user if there's an error
          void navigate({ to: '/' });
          return;
        }

        if (session?.user) {
          try {
            setUser(session.user);
            setLoading(false);
          } catch (userError) {
            console.error('Error setting user from callback:', userError);
            setLoading(false);
          }
        } else {
          setLoading(false);
        }

        // Navigate to home
        void navigate({ to: '/' });
      } catch (error) {
        console.error('Failed to handle auth callback:', error);
        setLoading(false);
        void navigate({ to: '/' });
      }
    };

    void handleAuthCallback();
  }, [navigate, setUser, setLoading]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-lg">Completing sign in...</p>
      </div>
    </div>
  );
}
